module.exports = __webpack_public_path__ + "static/media/fpo_banner.48156dde.svg";